import { Pagination, paginationToParams } from '../Pagination';

export interface PazaramaOrderFilter {
  pagination: Pagination;
}

export const getDefaultPazaramaOrderFilter = (): PazaramaOrderFilter => ({
  pagination: {
    page: 0,
    pageSize: 10,
  },
});

export const pazaramaOrderFilterToQueryParams = (
  filter: PazaramaOrderFilter,
) => ({
  ...paginationToParams(filter.pagination),
});
